const deleteCategory = () => {};

export default deleteCategory;
